/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseUUID } from '../models/ApiResponseUUID';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DriveHistoryExcelService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 주행기록 엑셀 다운로드 토큰 발급
   * 주행기록 엑셀 다운로드 토큰 발급
   * @returns ApiResponseUUID OK
   * @throws ApiError
   */
  public driveHistoryExcelDownloadToken({
    vin,
    clientTimezone,
    startDate = '20260908',
    endDate = '20260908',
    order = 'ASC',
    distanceUnit = 'KM',
    tagNames,
    tagIds,
    driverUserIds,
  }: {
    /**
     * vin
     */
    vin: string,
    clientTimezone?: string,
    startDate?: string,
    endDate?: string,
    /**
     * Order By
     */
    order?: 'ASC' | 'DESC',
    /**
     * 거리 단위 (KM/MI)
     */
    distanceUnit?: 'KM' | 'MI',
    /**
     * 태그 이름 목록 (쉼표 구분, OR 조건)
     */
    tagNames?: Array<string>,
    /**
     * 태그 식별자 목록 (쉼표 구분, OR 조건)
     */
    tagIds?: Array<string>,
    /**
     * 운전자 PUID 목록
     */
    driverUserIds?: Array<string>,
  }): CancelablePromise<ApiResponseUUID> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/excel/token',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
        'order': order,
        'distanceUnit': distanceUnit,
        'tagNames': tagNames,
        'tagIds': tagIds,
        'driverUserIds': driverUserIds,
      },
    });
  }
  /**
   * 엑셀파일 다운로드
   * 엑셀파일 다운로드
   * @returns string OK
   * @throws ApiError
   */
  public driveHistoryExcelDownload({
    token,
  }: {
    /**
     * Download Token
     */
    token: string,
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/excel/file',
      query: {
        'token': token,
      },
    });
  }
}
